import dayjs, { type Dayjs } from 'dayjs';
import * as z from 'zod';

import { itemInformationValidator, itemNameValidator, undefinedTransformer } from './helpers';

const campaignBaseFormSchema = z.object({
  name: itemNameValidator(),
  type: z.string(),
  code: z.string().trim().min(6, 'Min. 6 characters').max(20, 'Max. 20 characters'),
  url: z
    .string()
    .nullish()
    .transform(undefinedTransformer)
    .refine((value) => value === undefined || z.url().safeParse(value).success, { error: 'Invalid URL' }),
  status: z.string(),
  description: itemInformationValidator,
  validityPeriod: z.string(),
  fromTimestamp: z.custom<Dayjs>((value) => value instanceof dayjs, 'Invalid date').nullish(),
  toTimestamp: z.custom<Dayjs>((value) => value instanceof dayjs, 'Invalid date').nullish(),
});

export const campaignCreateFormSchema = campaignBaseFormSchema.extend({
  welcomeBonusId: z.string().trim().min(1, 'Bonus is required.'),
});

export const campaignEditFormSchema = campaignBaseFormSchema;

export type CampaignCreateFormData = z.infer<typeof campaignCreateFormSchema>;
export type CampaignEditFormData = z.infer<typeof campaignEditFormSchema>;
